import { Link } from 'react-router-dom'
import React, { useState, useEffect } from 'react'
import Axios from 'axios'
import K from '../services/k'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faKey } from '@fortawesome/free-solid-svg-icons'

function ResetPassword(props) {
  const [theme, setTheme] = React.useState('')
  useEffect(() => {
    if (theme !== props.theme) {
      setTheme(props.theme)
    }
  }, [props.theme])

  const [spinnerStatus, setSpinnerStatus] = useState(0)
  const [spinnerMessage, setSpinnerMessage] = useState('')

  const [fields, setState] = useState({
    token: 'aaa',
    password: '',
    c_password: '',
  })

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const handleFieldChange = (e) => {
    const queryParams = new URLSearchParams(window.location.search)
    const token = queryParams.get('token')

    setState({
      ...fields,
      token: token,
      [e.target.id]: e.target.value,
    })
  }

  const setPassword = async (e) => {
    e.preventDefault()

    setSpinnerStatus(1)
    if (fields.token === '') {
      setSpinnerStatus(2)
      setSpinnerMessage('Token required')
      return false
    } else {
      const resp = await Axios.post(`${K.baseUrl}users/password_reset`, fields)

      if (resp.data.resultcode === 0) {
        setSpinnerStatus(2)
        setSpinnerMessage(resp.data.message)
      } else if (resp.data.resultcode === 1) {
        setSpinnerStatus(3)
        setSpinnerMessage('Your password was changed successful!')
      }
    }
  }

  return (
    <div className={theme && theme === 'DARK' ? 'dark_theme' : 'light_theme'}>
      <div className="main-wrapper___ inner--page">
        <section
          className="login"
          style={{ paddingTop: '170px', paddingBottom: '100px' }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-6 offset-lg-3 col-md-6 offset-md-3">
                <div className="login-content">
                  <div className="heading-text text-center">
                    <h3>Reset Password</h3>
                    <p>Enter your new password.</p>
                  </div>
                  <div className="login-form">
                    <form className="mr-5 ml-5">
                      <div className="form-container">
                        <FontAwesomeIcon
                          style={{ position: 'absolute', margin: '15px' }}
                          icon={faKey}
                        />
                        <input
                          type="password"
                          name="password"
                          id="password"
                          placeholder="Password"
                          value={fields.password}
                          onChange={handleFieldChange}
                          required
                        />
                      </div>

                      <div className="form-container">
                        <FontAwesomeIcon
                          style={{ position: 'absolute', margin: '15px' }}
                          icon={faKey}
                        />
                        <input
                          type="password"
                          name="c_password"
                          id="c_password"
                          placeholder="Confirm Password"
                          value={fields.c_password}
                          onChange={handleFieldChange}
                          required
                        />
                      </div>

                      <div className="form-group text-left">
                        {spinnerStatus === 1 ? (
                          <span>
                            <p className="text-spinner-font">
                              <i className="fa fa-spinner fa-spin spinner-font"></i>
                              &nbsp;Please Wait...
                            </p>
                          </span>
                        ) : spinnerStatus === 2 ? (
                          <div className="alert alert-danger">
                            {spinnerMessage}
                          </div>
                        ) : spinnerStatus === 3 ? (
                          <div className="alert alert-success">
                            {spinnerMessage}
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>

                      <div className="form-group text-center">
                        <button
                          className="primary-btn mb-2 fwidth"
                          type="button"
                          onClick={setPassword}
                        >
                          Change Password
                        </button>
                        <text>
                          <Link to="/login">
                            <span className="colorgreen">
                              <b>Login here</b>
                            </span>
                          </Link>
                        </text>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}

export default ResetPassword
